import React, { useEffect, useState, useRef } from "react";
import Logo from "../assets/logo.png";
import { Link, NavLink  } from "react-router-dom";
import MobileLogo from "../assets/mobile-logo.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const getUserData = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    console.log(getUserData);
    setLoggedIn(getUserData);
  }, [location?.pathname]);

  useEffect(() => {
    console.log(location?.pathname);
    setExpanded(false);
  }, [location?.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setExpanded(false);
    };

    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClickOutside);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const logOut = () => {
    setExpanded(false);
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    navigate("/Login", { replace: true });
  };

  const handleShare = async () => {
    const { Share } = await import("@capacitor/share");

    await Share.share({
      title: 'Guruz App',
      text: 'Upskill Your Passion With Guruz app. Find trainers locally and join batches to learn your favourite sport or musical instrument or activity like yoga and pilates.',
      url:"https://onelink.to/ut4gy9",
      dialogTitle: 'Guruz App',
    });
  };

  return (
    <header className="guruz_header py-4">
      <div className="container">
        <div className="row align-items-center">
          <div className="logo d-none d-md-block col-3 col-md-2">
            <Link to="/">
              <img height="41" width="104" src={Logo} alt="" className="guruz-logo" />
            </Link>
          </div>

          <div className={`d-none links d-md-flex justify-content-start ${isLoggedIn ? "col-md-8" : "col-md-7"}`}>
            {isLoggedIn && (
              <ul className="d-flex mb-0 list-unstyled web-menu">
              <li className="mx-3">
                <NavLink to="/dashboard">Dashboard</NavLink>
              </li>
              <li className="mx-3">
              <NavLink to="/explore">Explore</NavLink>
            </li>
              <li className="mx-3">
                <NavLink to="/batches">Batches</NavLink>
              </li>
              <li className="mx-3">
                <NavLink to="/messages">Message</NavLink>
              </li>
              {getUserData?.data?.data?.account?.role === "guru" && (
              <li className="mx-3">
                <NavLink to="/financial-details">Financial Details</NavLink>
              </li>
              )}
              {getUserData?.data?.data?.account?.role === "student" && (
              <li className="mx-3">
                <NavLink to="/favourites">Favourites</NavLink>
              </li>
              )}
              
              <li className="mx-3">
              <NavLink to="/transactions">Transaction</NavLink>
              </li>
            </ul>
            )}
          
          </div>

          <div className="d-none links col-6 d-md-none justify-content-center">
            <ul className="d-flex mb-0 list-unstyled">
              <li className="mx-3">App Features</li>
              <li className="mx-3">Testimonials</li>
              {/* <li className="mx-3">
          <Link to="/home"> Blog </Link>
          </li>
          <li className="mx-3">
          <Link to="/home"> FAQ </Link>
          </li> */}
            </ul>
          </div>
          <div className={`col-5 d-md-none d-flex flex-row align-items-center justify-content-end ps-0`}>
            <Link to="/">
                <img src={Logo} alt="" className="guruz-logo" />
            </Link>
          </div>
           {isLoggedIn && (
          <Navbar ref={navbarRef} expand="lg" className="d-md-none position-absolute" expanded={expanded} onToggle={(exp) => setExpanded(exp)}>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
           {/* Mobile view navbar bar */}
            <Container className="menu-sec position-absolute">
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  {/* <NavLink to="#home">Home</NavLink>
                  <NavLink to="#link">App Features</NavLink>
                  <NavLink to="#link">Testimonials</NavLink> */}
<NavLink to="/dashboard">Dashboard</NavLink>
                  <NavLink to="/explore">Explore</NavLink>
                  <NavLink to="/batches">Batches</NavLink>
                  <NavLink to="/messages">Message</NavLink>
                  {getUserData?.data?.data?.account?.role === "guru" && (
                <NavLink to="/financial-details">Financial Details</NavLink>
              )}
                  <NavLink to="/favourites">Favourites</NavLink>
                  <NavLink to="/profilesetting">Profile setting</NavLink>
                  <NavLink onClick={() => logOut()}>Logout</NavLink>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar> )}
          <div
            className={`${
              isLoggedIn ? "d-none" : "d-flex"
            } col-7 ps-md-3 pe-md-0 col-md-3 flex-row align-items-center justify-content-end px-0 head-btns`}
          >
            <button className="border-0 logInBtn">
              <Link to="/Login">Log In</Link>
            </button>
            <button className="border-0 signUpBtn">
              <Link to="/Register">Sign Up</Link>
            </button>
          </div>
          <div
            className={`${
              isLoggedIn ? "d-flex" : "d-none"
            } col-7 ps-md-3 pe-md-0 col-md-2 flex-row align-items-center justify-content-end px-0 head-btns`}
          >
            <Dropdown>
              <Dropdown.Toggle
                variant="success"
                className="user-detail text-capitalize"
                id="dropdown-basic"
              >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', maxWidth: '150px' }}>
                  {isLoggedIn?.data?.data?.account?.firstname +' '+isLoggedIn?.data?.data?.account?.lastname}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>
                  <Link to="/profilesetting">Profile Setting</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link onClick={handleShare}>Share</Link>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => logOut()}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Link className="notification" to="/notification">
              <FontAwesomeIcon icon={faBell} />
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
